import * as React from 'react';
import './burgermenu.less';

export interface IBurgerMenuProps {
    allowAnimation?: boolean;
    collapsed: boolean;
    displayArrow?: boolean;
    style?: any;
    title?: string;
    onClick: (arg) => void;
}

export class BurgerMenu extends React.Component<IBurgerMenuProps, any> {
    menuClicked(arg) {
        this.props.onClick(arg);
    }

    render() {
        if ((global as any).document) { // for server-side rendering
            if (!this.props.collapsed) {
                document.body.classList.add("burger-on");
            } else {
                document.body.classList.remove("burger-on");
            }
        }

        return <div
            title={this.props.title ?? ""}
            className={'burger-menu' + (!this.props.collapsed ? ' expanded' : '')
                + (this.props.allowAnimation ? " allowanimation" : "")}
            onClick={this.menuClicked.bind(this)}
            style={this.props.style}
        >
            {this.props.displayArrow && <div className="burger displayArrow" />}
            {!this.props.displayArrow && <div className="burger">
                <div className="split1" />
                <div className="split2" />
                <div className="split3" />
            </div>}
            {/* <div className={"burger " + (this.props.displayArrow ? "displayArrow" : "")} /> */}
        </div>;
    }
}
